/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { colors, FullScreenModal } from '@blend/consumer-components';
import { JournalEntry } from './JournalEntry';

export namespace JournalEntryModal {
  export interface Props {
    isOpen: boolean;
    handleClose: () => void;
  }
}

export const JournalEntryModal: React.FC<JournalEntryModal.Props> = ({ isOpen, handleClose }) => {
  return (
    <FullScreenModal
      isOpen={isOpen}
      contentLabel={'Journal Entry'}
      handleClose={handleClose}
      headerText={'Journal Entry'}
      closeButtonColor={colors.darkerGray}
      backgroundStyleConfig={{ backgroundColor: colors.white }}
    >
      <JournalEntry handleClose={handleClose} />
    </FullScreenModal>
  );
};
